import AuthLayout from './AuthLayout.vue'
import AppLayout from './AppLayout.vue'
import Register from './pages/Register.vue'
import Login from './pages/Login.vue'
import ForgotPassword from './pages/ForgotPassword.vue'
import ResetPasswordForm from './pages/ResetPasswordForm.vue'
import NotFound from './pages/NotFound.vue'
import PaymentIsProcessing from "./pages/PaymentIsProcessing.vue";
import Account from './pages/Account.vue';
import User from './pages/User.vue';
import Inbox
    from "./pages/Inbox";
import Channels
    from "./pages/Channels";
import Settings
    from "./pages/Settings";
import Compose
    from "./pages/Compose";
import TestPrompt
    from "./pages/TestPrompt";

const routes = () => [
    {path: '/', component: AppLayout, meta: {
            auth: true
        },
        children: [
            {path: '/', name: 'inbox' ,component: Inbox},
            {path: '/channels', name: 'channels' ,component: Channels},
            {path: '/compose', name: 'compose' ,component: Compose},
            {path: '/settings', name: 'settings' ,component: Settings},
            {path: '/account', name: 'account' ,component: Account},
            {path: '/processing', name: 'processing' ,component: PaymentIsProcessing},
            {path: '/user', name: 'user' ,component: User},
            {path: '/test_prompt', name: 'test' ,component: TestPrompt},
        ]

    },
    {path: '/auth', component: AuthLayout, // All of these routes can also be accessed by logged in users, otherwise they get a 404.
        children: [
            {path: '/login', name: 'auth.login' ,component: Login},
            {path: '/register', name: 'landing.register', component: Register},
            {path: '/password/forgot', name: 'password.forgot', component: ForgotPassword},
            {path: '/password/reset/:token', name: 'password.reset', component: ResetPasswordForm},
        ]
    },
    {path: '*', component: NotFound}
];

export default routes();
